//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/NXObject.js";
let d=[[],[[[],"Perform",{},0,0],[[],"Remove",{},0,0],[[],"GetControl",{R_:{control:"NXObject"}},0,0],[["control"],"SetControl",{},1,0],[["num_targets"],"GetTargets",{R_:{targets:"NXObject[]"}},0,0],[["target"],"AddTarget",{},1,0],[["target"],"RemoveTarget",{},1,0],[[],"GetRoutedCondition",{R_:{condition:''}},0,0],[["condition"],"SetRoutedCondition",{},1,0],[["enable"],"EnableLogicalAssociation",{},1,0]],[]];
SPLM.Routing.RouteLogicalAssociation = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.RouteLogicalAssociation";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;